var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"pa-simple-fade"}},[(_vm.isOpen)?_c('div',{staticClass:"pa-connection-no-message-view"},[_c('div',{staticClass:"text-circle"},[_vm._v("初")]),_c('p',[_vm._v("まだ投稿はありません。")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }